const COUNTRY_CODE_MAP: Record<string, string> = {
  Thailand: "TH",
  Japan: "JP",
  Korea: "KR",
  China: "CN",
  Laos: "LA",
  Vietnam: "VN",
  Singapore: "SG",
  Malaysia: "MY",
  Indonesia: "ID",
  Philippine: "PH",
  Cambodia: "KH",
  Brunei: "BN",
};

export const getCountryCode = (countryName: string): string =>
  COUNTRY_CODE_MAP[countryName] || "";

export const getFlagUrl = (countryCode: string) =>
  countryCode
    ? `https://cdnjs.cloudflare.com/ajax/libs/flag-icons/7.5.0/flags/1x1/${countryCode.toLowerCase()}.svg`
    : "";
